import { render, staticRenderFns } from "./BaseInputButton.vue?vue&type=template&id=47471d9c&scoped=true&"
import script from "./BaseInputButton.vue?vue&type=script&lang=js&"
export * from "./BaseInputButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputButton.vue?vue&type=style&index=0&id=47471d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47471d9c",
  null
  
)

export default component.exports